import store from '@/state/store'

/**
 * Check Line Order feature access by comparing whoami company id
 * with company id list in `customFeature.LineOrder`.
 * @param {number|string|null|undefined} companyId
 * @returns {boolean}
 */
export const hasLineOrderFeatureAccess = (companyId = store.state.identity.whoami?.companyId) => {
  if (companyId === null || companyId === undefined) return false

  const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']
  if (typeof getFeatureFlagValue !== 'function') return false

  const featureData = getFeatureFlagValue('customFeature.LineOrder')
  if (!Array.isArray(featureData?.company_id)) return false

  return featureData.company_id.map(String).includes(String(companyId))
}
